import { KeyboardArrowDown } from "@mui/icons-material";
import styles from "../page.module.css";
import { useEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";
import { MdErrorOutline } from "react-icons/md";

export default function Selector({
  isYearBuilt,
  activeValue,
  yearBuiltError,
  buyersFeeError,
  onClick,
}: {
  isYearBuilt: boolean;
  activeValue?: number;
  yearBuiltError?: string;
  buyersFeeError?: string;
  onClick: (newValue: number) => void;
}) {
  const t = useTranslations("NewListing.yearAndBuyerFee");
  const currentYear = new Date().getFullYear();
  const [isActive, setIsActive] = useState(false);
  const toggleRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        toggleRef.current &&
        !toggleRef.current.contains(event.target as Node)
      ) {
        setIsActive(false);
      }
    };
    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);

  return isYearBuilt ? (
    <div id="year_built" className={styles.inputItem}>
      <h3 className={`${styles.fieldTitle} ${yearBuiltError && styles.error}`}>
        {t("yearBuilt")}*
      </h3>
      {yearBuiltError && (
        <p className={styles.errorText}>
          {t(yearBuiltError)}
          <span>
            <MdErrorOutline />
          </span>
        </p>
      )}
      <div className={styles.selectorWrapper} ref={toggleRef}>
        <button
          className={`${styles.pickerWrapper} ${
            yearBuiltError && styles.error
          }`}
          onClick={() => {
            setIsActive(!isActive);
          }}
        >
          <span className={styles.selected}>
            {activeValue ? `${activeValue}` : t("pick")}
          </span>
          <KeyboardArrowDown />
        </button>
        {isActive && (
          <div className={styles.selection}>
            {[...Array(6)].map((_, i, arr) => {
              const reverseIndex = arr.length - 1 - i;
              const value = currentYear + reverseIndex;
              return (
                <button
                  className={styles.selectionWrapper}
                  key={value}
                  onClick={(e) => {
                    onClick(value);
                    setIsActive(!isActive);
                  }}
                >
                  <span>{value}</span>
                  <div className={styles.separator}></div>
                </button>
              );
            })}
            {[...Array(100)].map((_, i) => {
              const value = currentYear - i - 1;
              return (
                <button
                  className={styles.selectionWrapper}
                  key={value}
                  onClick={(e) => {
                    onClick(value);
                    setIsActive(!isActive);
                  }}
                >
                  <span>{value}</span>
                  <div className={styles.separator}></div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  ) : (
    <div id="buyers_fee" className={styles.inputItem}>
      <h3 className={`${styles.fieldTitle} ${buyersFeeError && styles.error}`}>
        {t("buyersFee")}*
      </h3>
      {buyersFeeError && (
        <p className={styles.errorText}>
          {t(buyersFeeError)}
          <span>
            <MdErrorOutline />
          </span>
        </p>
      )}
      <div className={styles.selectorWrapper} ref={toggleRef}>
        <button
          className={`${styles.pickerWrapper} ${
            buyersFeeError && styles.error
          }`}
          onClick={() => {
            setIsActive(!isActive);
          }}
        >
          <span className={styles.selected}>
            {activeValue ? `${activeValue}%` : "0%"}
          </span>
          <KeyboardArrowDown />
        </button>
        {isActive && (
          <div className={styles.selection}>
            {[...Array(31)].map((_, i) => (
              <button
                className={styles.selectionWrapper}
                key={i}
                onClick={(e) => {
                  onClick(i);
                  setIsActive(!isActive);
                }}
              >
                <span>{i}%</span>
                <div className={styles.separator}></div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
